import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import ActionIcon from '../../../components/custom/ActionIcon';
import BackButton from '../../../components/custom/BackButton';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    confirm: () => Promise<void>;
}

export default function ModalConfirm ({
    modal,
    setModal,
    confirm
}: Props) {

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>End User Access</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h4>This action will immediately revoke the employee's access to the platform and notify the Corporate HR Team of the request.</h4>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'check'} onClick={confirm} simulateLoading />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;